import { Input } from "@/components/ui/input";

export default function ChartFilterBar({
  labels = [],
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search",
  searchTestId,
  testId,
  selects = {},
}) {
  return (
    <div data-testid={testId} className="mb-3 flex flex-wrap items-center gap-2">
      {labels.map((label) => {
        const select = selects[label];
        if (select) {
          return (
            <select
              key={label}
              aria-label={label}
              data-testid={select.testId}
              value={select.value}
              onChange={(event) => select.onChange?.(event.target.value)}
              className="h-9 rounded-md border border-slate-200 bg-white px-2 text-slate-700"
            >
              {(select.options || []).map((option) => (
                <option key={option.value || option.label} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          );
        }
        return (
          <select
            key={label}
            disabled
            aria-label={label}
            title="Independent filters will be available later"
            className="h-9 rounded-md border border-slate-200 bg-white px-2 text-slate-500"
          >
            <option>{label}</option>
          </select>
        );
      })}
      <Input
        value={searchValue}
        onChange={(event) => onSearchChange?.(event.target.value)}
        placeholder={searchPlaceholder}
        data-testid={searchTestId}
        className="h-9 w-44 bg-white"
      />
    </div>
  );
}
